<section id="blogs">
	<div class="banner" fxLayout="row" fxLayoutAlign="center center">
		<h1 class="heading-1 title-text mb-16">Blogs</h1>
	</div>
	<div class="layout-container">
		<div
			fxLayout="row wrap"
			*ngIf="posts$ | async"
			fxLayout.lt-sm="column"
			fxLayoutGap="grid"
			class="card-parent"
		>
			<mat-card *ngFor="let post of posts$ | async" class="mat-container">
				<a [routerLink]="post.route">
					<img
						mat-card-image
						[lazyLoad]="post.listImage"
						[alt]="post.title"
						class="d-block rounded"
					/>
					<div class="text-muted font-size-14">
						<div class="calendar-date">
							<ic-icon [icon]="calenderIcon"></ic-icon>
							{{ post.date | date: 'MMM d, y' }}
						</div>
						<div class="perm-identity">
							<ic-icon [icon]="userIcon"></ic-icon>
							{{ post.author }}
						</div>
					</div>

					<h3 class="heading-3 title-text">
						{{ post.title }}
					</h3>

					<p class="text-muted font-size-16">
						{{ post.description | truncate: 110 }}
					</p>
					<div class="text-primary text-semibold">
						Learn More
						<span class="ml-2 right-icon">&#8594;</span>
					</div>
				</a>
			</mat-card>
		</div>
	</div>
</section>
